import { createStyles, Theme } from "@material-ui/core";

export const commonClasses = createStyles({
    fullWidth: { width: "100%" },
    fullHeight: { height: "100%" },
    displayFlex: { display: "flex" },
    displayNone: { display: "none" },
    alignItemsCenter: { alignItems: "center" },
    alignSelfCenter: { alignSelf: "center" },
    alignSelfEnd: { alignSelf: "flex-end" },
    justifyContentCenter: { justifyContent: "center" },
    textTransformNone: { textTransform: "none" },
    positionRelative: { position: "relative" },
    overflowHidden: { overflow: "hidden" },
    cursorPointer: { cursor: "pointer" },
    userSelectNone: { userSelect: "none" },
    bold: { fontWeight: "bold" },
    reverseIcon: {
        transform: "scaleX(-1)",
    },
});

export const spacing = (theme: Theme) =>
    createStyles({
        p2: {
            padding: theme.spacing(2),
        },
        py2: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
        pt2: {
            paddingTop: theme.spacing(2),
        },
        pr2: {
            paddingRight: theme.spacing(2),
        },
        pb2: {
            paddingBottom: theme.spacing(2),
        },
        pl2: {
            paddingLeft: theme.spacing(2),
        },
        p: {
            padding: theme.spacing(1),
        },
        pt: {
            paddingTop: theme.spacing(1),
        },
        pr: {
            paddingRight: theme.spacing(1),
        },
        pb: {
            paddingBottom: theme.spacing(1),
        },
        pl: {
            paddingLeft: theme.spacing(1),
        },
        my2: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        mb2: {
            marginBottom: theme.spacing(2),
        },
        my: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        mx: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        mt: {
            marginTop: theme.spacing(1),
        },
        mr: {
            marginRight: theme.spacing(1),
        },
        mb: {
            marginBottom: theme.spacing(1),
        },
        ml: {
            marginLeft: theme.spacing(1),
        },
    });
